import clsx from 'clsx';
import { format } from 'date-fns';

type LabelDateProps = {
  date: string | Date;
  label?: string;
  className?: string;
  formatDate?: string;
  showTime?: boolean;
  timeFormat?: string;
};

export const LabelDate: React.FC<LabelDateProps> = ({
  date = new Date(),
  label,
  className,
  formatDate = 'yyyy-MM-dd',
  showTime = false,
  timeFormat = 'HH:mm:ss',
}) => {
  const parsedDate = new Date(date);
  const isValidDate = !isNaN(parsedDate.getTime());
  const fallbackDate = new Date();

  const datePart = format(isValidDate ? parsedDate : fallbackDate, formatDate);
  const timePart = showTime
    ? ' ' + format(isValidDate ? parsedDate : fallbackDate, timeFormat)
    : '';

  return (
    <div className={clsx(className)}>
      <span className="mr-sm text-mainText text-small">{datePart}</span>
      {timePart && (
        <span className="mr-sm text-secondary text-tiny">{timePart}</span>
      )}
      {label && (
        <>
          <span className="font-bold">&#8226;</span>
          <span className="ml-sm">{label}</span>
        </>
      )}
    </div>
  );
};
